import { useMemo } from 'react';
import { clsx } from 'clsx';
import { TableColumn, TableRow } from './interfaces/table';
import { Table, TableProps } from './Table';

export interface TableShimmerProps {
  dataId?: string;
  columnsCount: number;
  rowsCount: number;
  tableProps?: Partial<TableProps>;
}

const shimmerWidth = 122;

export function TableShimmer({
  dataId = '',
  columnsCount,
  rowsCount,
  tableProps
}: TableShimmerProps) {
  const columns = useMemo<TableColumn<object>[]>(() => {
    return Array.from({ length: columnsCount }).map((_, index) => ({
      id: String(index),
      field: String(index),
      headerName: String(index),
      width: shimmerWidth,
      renderCell: () => (
        <span
          className={clsx(
            'd-flex shimmer shimmer-line',
            index === columnsCount - 1 && 'align-items-end'
          )}
          style={{ width: shimmerWidth }}
        />
      ),
      renderHeaderCell: () => (
        <span className='d-flex shimmer shimmer-line flex' style={{ width: shimmerWidth }} />
      ),
      isFlexible: index === columnsCount - 1,
      headerCellAlign: index === columnsCount - 1 ? 'flex-end' : 'auto',
      cellClassName: 'd-flex'
    }));
  }, [columnsCount]);

  const rows = useMemo<TableRow<object>[]>(() => {
    return Array.from({ length: rowsCount }).map((_, index) => ({
      data: {},
      id: index
    }));
  }, [rowsCount]);

  return (
    <Table dataId={dataId} columns={columns} rows={rows} withoutHeaderDivider {...tableProps} />
  );
}
